enum Stats {
  NumCuratedTrails = 500, // thousand
  NumUsers = 100, // million
  LoggedDistanceMeters = 4023360000000 // meters
}

export default Stats;
